import { OrderLineEntry } from '../type'
import { Nullable } from '../../../core/type'
import { isNullOrEmpty, resolveNumber } from '../../../core/until'
import { getOnHandQuantity } from '../model-mapper/order-map-entity-to-entry'

type AvailabilityLine = Partial<Pick<OrderLineEntry, 'item' | 'allocatedTakeWithQuantity' | 'allocatedItemId'>>
type AllocationLine = AvailabilityLine & Partial<Pick<OrderLineEntry, 'quantity'>>

export const getAvailableInStockQuantity = (line?: AvailabilityLine): number =>
  getOnHandQuantity(line?.item)

export const getAllocatedTakeWithQuantity = (line?: AvailabilityLine): number => {
  const itemId = line?.item?.id

  if (!itemId || itemId !== line?.allocatedItemId)
    return 0

  return resolveNumber(line?.allocatedTakeWithQuantity, {changeNegativeToZero: true})
}

export const getMaxTakeWithQuantity = (line?: AvailabilityLine): number =>
  getAvailableInStockQuantity(line) + getAllocatedTakeWithQuantity(line)

export const isReturnQuantity = (quantity?: Nullable<number>): boolean =>
  resolveNumber(quantity) < 0

export const resolveTakeWithAndBackOrderQuantities = (
  line?: AllocationLine,
  takeWithEnteredByUser?: Nullable<number>,
): Pick<OrderLineEntry, 'takeWithQuantity' | 'backOrderQuantity'> => {
  const enteredQuantity = resolveNumber(line?.quantity)

  if (isReturnQuantity(enteredQuantity))
    return {
      takeWithQuantity: enteredQuantity,
      backOrderQuantity: 0,
    }

  const quantity = resolveNumber(line?.quantity, {changeNegativeToZero: true})
  const validTakeWithQuantity = Math.min(quantity, getMaxTakeWithQuantity(line))

  const takeWithQuantity = isNullOrEmpty(takeWithEnteredByUser)
    ? validTakeWithQuantity
    : Math.min(
      resolveNumber(takeWithEnteredByUser, {changeNegativeToZero: true}),
      validTakeWithQuantity,
    )

  return {
    takeWithQuantity,
    backOrderQuantity: resolveNumber(quantity - takeWithQuantity, {changeNegativeToZero: true}),
  }
}
